import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthModel } from '@sym-nx/auth-lib';
import { authModel } from './auth/login/auth.obj';
import { BulkMeterService } from './services/bulk-meter.service';
import { PropertyService } from './services/property.service';
import { TenantsService } from './services/tenants.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexModule, FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Storage } from '@ionic/storage';
import { OfflineIndicatorComponent } from './offline-indicator';
import { SwUpdate } from '@angular/service-worker';

declare var window: any;

@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    OfflineIndicatorComponent,
    MatButtonModule,
    FlexModule,
    FlexLayoutModule,
    MatIconModule,
    MatChipsModule,
    MatCardModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'sac-mobile-v3';
  dataInput: AuthModel = authModel;

  updateAvailable = false;
  deferredPrompt: any = null;
  pwaInstallAvailable = false;

  constructor(
    private swUpdate: SwUpdate,
    private cdr: ChangeDetectorRef,
    private storage: Storage,
    private bulkMeterService: BulkMeterService,
    private tenantService: TenantsService,
    private propertyService: PropertyService
  ) {
    console.log('AppComponent constructor called');

    if (swUpdate.isEnabled) {
      console.log('Service worker is enabled and running');
      swUpdate.versionUpdates.subscribe(evt => {
        console.log('SW Event:', evt.type, evt);
        if (evt.type === 'VERSION_READY') {
          this.updateAvailable = true;
        }
      });
    } else {
      console.log('Service worker not enabled');
    }
  }

  ngOnInit() {
    console.log('AppComponent initialized, checking for SW updates...');

    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate()
        .then(hasUpdate => {
          console.log('Manual checkForUpdate:', hasUpdate);
          if (hasUpdate) {
            this.updateAvailable = true;
          }
        })
        .catch(err => console.error('Error when checking for update:', err));
    }

    // Handle PWA install prompt
    window.addEventListener('beforeinstallprompt', (event: Event) => {
      console.log('PWA not installed yet');
      event.preventDefault();
      this.deferredPrompt = event;
      this.pwaInstallAvailable = true;
      this.cdr.detectChanges();
    });

    window.addEventListener('appinstalled', () => {
      console.log('PWA installed');
      this.pwaInstallAvailable = false;
      this.deferredPrompt = null;
      this.cdr.detectChanges();
    });
  }

  updateApp() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.activateUpdate().then(() => {
        console.log('New version activated, clearing old caches...');

        if ('caches' in window) {
          caches.keys().then(keys => {
            keys.forEach(key => {
              caches.delete(key).then(deleted => {
                if (deleted) {
                  console.log(`Cache ${key} deleted`);
                }
              });
            });
          });
        }

        setTimeout(() => {
          document.location.reload();
        }, 500);
      }).catch(err => {
        console.error('Error activating update:', err);
      });
    }
  }

  installPwa() {
    if (!this.deferredPrompt) return;

    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('PWA setup accepted');
      } else {
        console.log('PWA setup dismissed');
      }
      this.deferredPrompt = null;
      this.pwaInstallAvailable = false;
      this.cdr.detectChanges();
    });
  }
}
